<div class="content">
  <div class="sidebar standard-listing" *ngVar="getLoadingList() as loadingList">
    <div class="header">
      <button mat-button class="tab" [ngClass]="{selected: sidebarTab == 'review'}" (click)="setSidebarTab('review')">Review</button>
      <button mat-button class="tab" [ngClass]="{selected: sidebarTab == 'modify'}" (click)="setSidebarTab('modify')">Modify</button>
    </div>
    <input id="huddy-compass-filter-input" type="text" class="listing-filter" placeholder="Filter by name or provider" [(ngModel)]="filterText" />
    <div *ngIf="loadingList.loading" class="listings">
      <listing-component *ngFor="let listing of [1,2,3,4,5,6,7,8,9]" [skeleton]="true" aboveTitle="true"></listing-component>
    </div>
    <div *ngIf="!loadingList.loading && loadingList.list.length == 0" class="empty-state">
      Nothing to show
    </div>
    <div *ngIf="!loadingList.loading && loadingList.list.length > 0" class="listings">
      <listing-component *ngFor="let item of getFilteredItems()" [title]="item.name"
        [desc]="getVersion(item)" [aboveTitle]="item.providerName"
        [selected]="isSelected(item.id)" (click)="select(item.id)"></listing-component>
    </div>
    <button mat-icon-button *ngIf="reviews.loaded && products.loaded" class="circle-button" [title]="(reviews.loading || products.loading) ? '' : 'Refresh'" [disabled]="reviews.loading || products.loading || submitting" (click)="update()">
      <div class="icon-container refresh" [ngClass]="{working: isRefreshing()}"><img src="assets/content-icon/ic-17.svg" class="icon" /></div>
    </button>
  </div>
  <div *ngVar="getSelected() as selected" class="body" [ngClass]="{scrollable: !(getLoadingList().loading || getSelectedCompass())}">
    <div *ngIf="(selected && !getSelectedCompass()) || getLoadingList().loading" class="body-content skeleton">
      <div #scrollableContent class="scrollable-content">
        <div class="page-title-container"><span class="page-title skeleton-animation"></span></div>
        <div class="tabs">
          <button mat-button class="body-standard-tab selected" disabled>
            <span class="text">General Information</span>
          </button>
          <button mat-button class="body-standard-tab" disabled>
            <span class="text">Trackables</span>
          </button>
          <button mat-button class="body-standard-tab" disabled>
            <span class="text">Assessment</span>
          </button>
          <button mat-button class="body-standard-tab" disabled>
            <span class="text">Score Summary</span>
          </button>
        </div>
        <div class="fields skeleton">
          <div class="input-area">
            <div class="input-container double">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="input-container">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="input-container">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="input-container">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="input-container">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="input-container double">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="input-container double">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="input-container double">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="sidebarTab == 'review'" class="buttons">
        <button mat-button class="text-button secondary" disabled>Reject</button>
        <button mat-button class="text-button" disabled>Approve</button>
      </div>
      <div *ngIf="sidebarTab == 'modify'" class="buttons">
        <button mat-button class="text-button" disabled>Modify</button>
      </div>
    </div>
    <div class="body-content" *ngIf="!(getLoadingList().loading || selected)">
      <div class="page-empty-state-area">
        <img src="assets/empty-state/journal_empty_filter.svg" class="empty-state-image">
        <span class="title">{{getEmptyStateTitle()}}</span>
        <span class="desc">{{getEmptyStateDesc()}}</span>
      </div>
    </div>
    <div *ngIf="getSelectedCompass() && !getLoadingList().loading" class="body-content">
      <div #scrollableContent class="scrollable-content" *ngVar="getSelectedCompass() as selectedCompass">
        <div #sectionId class="section-id">{{selected.id}},{{selected.groupIndex}}</div>
        <div class="page-title-container"><span class="page-title">{{selectedCompass.name}}</span></div>
        <div class="tabs">
          <button mat-button class="body-standard-tab" [ngClass]="{selected: getTab(selected.id) == 0}" (click)="setTab(0, selected.id)">
            <span class="text">General Information</span>
          </button>
          <button mat-button class="body-standard-tab" [ngClass]="{selected: getTab(selected.id) == 1}" (click)="setTab(1, selected.id)">
            <span class="text">Trackables</span>
          </button>
          <button mat-button class="body-standard-tab" [ngClass]="{selected: getTab(selected.id) == 2}" (click)="setTab(2, selected.id)">
            <span class="text">Assessment</span>
          </button>
          <button mat-button class="body-standard-tab" [ngClass]="{selected: getTab(selected.id) == 3}" (click)="setTab(3, selected.id)">
            <span class="text">Score Summary</span>
          </button>
        </div>
        <div *ngIf="getTab(selected.id) == 0" class="fields">
          <div *ngVar="usesCustomScoreClass(selectedCompass) as useCustomScoreClass" class="input-area minimal">
            <div class="input-container double" *ngVar="selectedCompass.name as fieldValue" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Compass Name</span>
              </div>
              <input type="text" class="input" [ngModel]="fieldValue" disabled />
            </div>
            <div class="input-container" *ngVar="makeReadableText(selectedCompass.status) as fieldValue" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Publish Status</span>
              </div>
              <input type="text" class="input" [ngModel]="fieldValue" disabled />
            </div>
            <div class="input-container" *ngVar="selectedCompass.providerName as fieldValue" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Provider Name</span>
              </div>
              <input type="text" class="input" [ngModel]="fieldValue" disabled />
            </div>
            <div class="input-container" *ngVar="selectedCompass.scoreName as fieldValue" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Score Name</span>
              </div>
              <input type="text" class="input" [ngModel]="fieldValue" disabled />
            </div>
            <div class="input-container" *ngVar="selectedCompass.conditionName as fieldValue" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Condition Name</span>
              </div>
              <input type="text" class="input" [ngModel]="fieldValue" disabled />
            </div>
            <div class="input-container" [ngClass]="{double: !useCustomScoreClass}" *ngVar="makeReadableBoolean(useCustomScoreClass) as fieldValue" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Use Custom Score Class</span>
              </div>
              <input type="text" class="input" [ngModel]="fieldValue" disabled />
            </div>
            <div class="input-container" [ngClass]="{hidden: !useCustomScoreClass}" *ngVar="selectedCompass.scoreClass as fieldValue" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Score Class</span>
              </div>
              <input type="text" class="input" [ngModel]="fieldValue" disabled />
            </div>
            <div class="input-container double" *ngVar="selectedCompass.description as fieldValue" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Description</span>
              </div>
              <textarea textareaAutoheight type="text" class="input" [ngModel]="fieldValue" disabled></textarea>
            </div>
            <div class="input-container double" *ngVar="selectedCompass.longDescription as fieldValue" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Product Page Description</span>
              </div>
              <textarea textareaAutoheight type="text" class="input" [ngModel]="fieldValue" disabled></textarea>
            </div>
            <div class="input-container double" [ngClass]="{hidden: !(selectedCompass.scoreSummmaryGroups?.length > 1)}">
              <div class="label-line">
                <span class="label">Score Group Names</span>
              </div>
              <div class="input bubbles">
                <div *ngFor="let scoreGroup of selectedCompass.scoreSummmaryGroups; index as i" class="bubble disabled">
                  <input [inputAutowidth]="52" *ngVar="scoreGroup.name as fieldValue" type="text" class="bubble-input" [ngModel]="fieldValue" disabled />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="getTab(selected.id) == 1" class="fields">
          <div *ngIf="!(selectedCompass.trackables?.length > 0)" class="empty-state">
            Nothing to show
          </div>
          <div class="input-area minimal card has-title no-overflow" *ngFor="let trackable of selectedCompass.trackables">
            <div class="double card-title">
              <span class="title">{{trackable.name}}</span>
            </div>
            <div class="input-container" *ngVar="trackable.name as fieldValue" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Trackable Name</span>
              </div>
              <input type="text" class="input" [ngModel]="fieldValue" disabled />
            </div>
            <div class="input-container" *ngVar="makeReadableText(trackable.trackableType) as fieldValue" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Trackable Type</span>
              </div>
              <input type="text" class="input" [ngModel]="fieldValue" disabled />
            </div>
            <div class="input-container double" [ngClass]="{hidden: !trackable.isIntegrated}" *ngVar="trackableIntegrationsToString(trackable.integrations) as fieldValue" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Allowed Integrations</span>
              </div>
              <input type="text" class="input" [ngModel]="fieldValue" disabled />
            </div>
            <div class="input-container" [ngClass]="{hidden: !isEvidence(trackable)}" *ngVar="trackable.unitsOfMeasure as fieldValue" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Units</span>
              </div>
              <input type="text" class="input" [ngModel]="fieldValue" disabled />
            </div>
            <div class="input-container" [ngClass]="{hidden: !isEvidence(trackable)}" *ngVar="trackable.normalValue as fieldValue" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Normal Value</span>
              </div>
              <input type="text" class="input" [ngModel]="fieldValue" disabled />
            </div>
            <div class="input-container double" [ngClass]="{hidden: !isEvidence(trackable)}" *ngVar="makeReadableBoolean(trackable.additive) as fieldValue" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Is Additive</span>
              </div>
              <input type="text" class="input" [ngModel]="fieldValue" disabled />
            </div>
            <div *ngIf="!usesCustomScoreClass(selectedCompass)" class="double">
              <div class="subheader-line">
                <div class="subheader-text">
                  <span class="subheader">{{hasMultipleGroups(selectedCompass) ? 'Scales' : 'Scale'}}</span>
                </div>
              </div>
              <div *ngIf="!(trackable.trackableValuations?.length > 0)" class="empty-state">
                Nothing to show
              </div>
              <div class="card input-area no-overflow" *ngFor="let valuation of (trackable.trackableValuations || [])">
                <div class="input-container" [ngClass]="{hidden: !hasMultipleGroups(selectedCompass)}" *ngVar="getGroupNames(selectedCompass, valuation.groupGuids) as fieldValue" [title]="fieldValue">
                  <div class="label-line">
                    <span class="label">Score Groups</span>
                  </div>
                  <input type="text" class="input" [ngModel]="fieldValue" disabled />
                </div>
                <div class="input-container" *ngVar="makeReadableText(getValuationScaleType(valuation)) as fieldValue" [title]="fieldValue">
                  <div class="label-line">
                    <span class="label">Scale Type</span>
                  </div>
                  <input type="text" class="input" [ngModel]="fieldValue" disabled />
                </div>
                <div *ngIf="getValuationScaleType(valuation) != null" class="double">
                  <div class="subheader-line">
                    <div class="subheader-text">
                      <span class="subheader">Scale Ranges</span>
                    </div>
                  </div>
                  <div *ngIf="!(valuation.scale?.length > 0)" class="empty-state">
                    Nothing to show
                  </div>
                  <div class="card input-area" *ngFor="let range of (valuation.scale || []); index as k">
                    <div class="input-container" *ngVar="(k + 1) as fieldValue" [title]="fieldValue">
                      <div class="label-line">
                        <span class="label">Range ID</span>
                      </div>
                      <input type="text" class="input" [ngModel]="fieldValue" disabled />
                    </div>
                    <div class="input-container" *ngVar="range.weight as fieldValue" [title]="fieldValue">
                      <div class="label-line">
                        <span class="label">Weight</span>
                      </div>
                      <input type="text" class="input" [ngModel]="fieldValue" disabled />
                    </div>
                    <div class="input-container" *ngVar="range.minimum as fieldValue" [title]="fieldValue">
                      <div class="label-line">
                        <span class="label">Minimum</span>
                      </div>
                      <input type="text" class="input" [ngModel]="fieldValue" disabled />
                    </div>
                    <div class="input-container" *ngVar="range.maximum as fieldValue" [title]="fieldValue">
                      <div class="label-line">
                        <span class="label">Maximum</span>
                      </div>
                      <input type="text" class="input" [ngModel]="fieldValue" disabled />
                    </div>
                    <div class="input-container" [ngClass]="{hidden: !isCount(range)}" *ngVar="range.countMinimum as fieldValue" [title]="fieldValue">
                      <div class="label-line">
                        <span class="label">Count Minimum</span>
                      </div>
                      <input type="text" class="input" [ngModel]="fieldValue" disabled />
                    </div>
                    <div class="input-container" [ngClass]="{hidden: !isCount(range)}" *ngVar="range.countMaximum as fieldValue" [title]="fieldValue">
                      <div class="label-line">
                        <span class="label">Count Maximum</span>
                      </div>
                      <input type="text" class="input" [ngModel]="fieldValue" disabled />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="getTab(selected.id) == 2" class="fields">
          <div class="input-area minimal" *ngVar="selectedCompass.assessment?.frequencyReminder != null as hasHuddyReminder">
            <div class="input-container double" *ngVar="selectedCompass.assessment?.conclusionText as fieldValue" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Conclusion Text</span>
              </div>
              <input type="text" class="input" [ngModel]="fieldValue" disabled />
            </div>
            <div class="input-container" *ngVar="selectedCompass.assessment?.attribution as fieldValue" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Attribution</span>
              </div>
              <input type="text" class="input" [ngModel]="fieldValue" disabled />
            </div>
            <div class="input-container" *ngVar="selectedCompass.assessment?.attributionLink as fieldValue" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Attribution Link</span>
              </div>
              <input type="text" class="input" [ngModel]="fieldValue" disabled />
            </div>
            <div class="input-container" *ngVar="makeReadableBoolean(selectedCompass.assessment?.showPreviousAnswers) as fieldValue" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Show Previous Answers</span>
              </div>
              <input type="text" class="input" [ngModel]="fieldValue" disabled />
            </div>
            <div class="input-container" *ngVar="makeReadableBoolean(hasHuddyReminder) as fieldValue"
              [title]="fieldValue">
              <div class="label-line">
                <span class="label">Has Huddy Reminder</span>
              </div>
              <input type="text" class="input" [ngModel]="fieldValue" disabled />
            </div>
            <div *ngIf="hasHuddyReminder" class="subheader-line double">
              <div class="subheader-text">
                <span class="subheader">Reminder</span>
              </div>
            </div>
            <div class="input-container double" *ngVar="selectedCompass.assessment?.frequencyReminder?.promptText as fieldValue" [ngClass]="{hidden: !hasHuddyReminder}" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Prompt</span>
              </div>
              <input type="text" class="input" [ngModel]="fieldValue" disabled />
            </div>
            <div class="input-container double" *ngVar="selectedCompass.assessment?.frequencyReminder?.logForPromptText as fieldValue" [ngClass]="{hidden: !hasHuddyReminder}" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Journaled For Prompt</span>
              </div>
              <input type="text" class="input" [ngModel]="fieldValue" disabled />
            </div>
            <div class="input-container" *ngVar="selectedCompass.assessment?.frequencyReminder?.daysBetweenAssessments as fieldValue" [ngClass]="{hidden: !hasHuddyReminder}" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Days Between</span>
              </div>
              <input type="text" class="input" [ngModel]="fieldValue" disabled />
            </div>
            <div class="input-container" *ngVar="selectedCompass.assessment?.frequencyReminder?.buttonText as fieldValue" [ngClass]="{hidden: !hasHuddyReminder}" [title]="fieldValue">
              <div class="label-line">
                <span class="label">Button Text</span>
              </div>
              <input type="text" class="input" [ngModel]="fieldValue" disabled />
            </div>
            <div class="double">
              <div class="subheader-line">
                <div class="subheader-text">
                  <span class="subheader">Questions</span>
                </div>
              </div>
              <div *ngIf="!(selectedCompass.assessment?.questions?.length > 0)" class="empty-state">
                Nothing to show
              </div>
              <div class="card-container" *ngFor="let answerable of (selectedCompass.assessment?.questions || [])">
                <div class="card title-only no-overflow input-area" *ngVar="answerableIsButton(answerable) as isButton">
                  <div class="double card-title">
                    <span class="title">{{(answerable.question || '').trim() || 'Question'}}</span>
                  </div>
                  <div class="input-container double" *ngVar="answerable.question as fieldValue" [title]="fieldValue">
                    <div class="label-line">
                      <span class="label">Question</span>
                    </div>
                    <input type="text" class="input" [ngModel]="fieldValue" disabled />
                  </div>
                  <div class="input-container double" *ngVar="answerable.caredForQuestion as fieldValue" [title]="fieldValue">
                    <div class="label-line">
                      <span class="label">Journaled For Question</span>
                    </div>
                    <input type="text" class="input" [ngModel]="fieldValue" disabled />
                  </div>
                  <div class="input-container" [ngClass]="{double: !isButton}" *ngVar="makeReadableText(answerable.answerType) as fieldValue" [title]="fieldValue">
                    <div class="label-line">
                      <span class="label">Answer Type</span>
                    </div>
                    <input type="text" class="input" [ngModel]="fieldValue" disabled />
                  </div>
                  <div class="input-container" [ngClass]="{hidden: !isButton}" *ngVar="makeReadableBoolean(answerable.multiAnswer) as fieldValue" [title]="fieldValue">
                    <div class="label-line">
                      <span class="label">Is Multi-Answer</span>
                    </div>
                    <input type="text" class="input" [ngModel]="fieldValue" disabled />
                  </div>
                  <div *ngIf="isButton" class="double">
                    <div class="subheader-line">
                      <div class="subheader-text">
                        <span class="subheader">Buttons</span>
                      </div>
                    </div>
                    <div *ngIf="!(answerable.answers?.length > 0)" class="empty-state">
                      Nothing to show
                    </div>
                    <div class="card input-area no-overflow" *ngFor="let button of (answerable.answers || [])">
                      <div class="input-container double" *ngVar="button.answer as fieldValue" [title]="fieldValue">
                        <div class="label-line">
                          <span class="label">Button Text</span>
                        </div>
                        <input type="text" class="input" [ngModel]="fieldValue" disabled />
                      </div>
                      <div *ngIf="!usesCustomScoreClass(selectedCompass)" class="double">
                        <div class="subheader-line">
                          <div class="subheader-text">
                            <span class="subheader">{{hasMultipleGroups(selectedCompass) ? 'Weights' : 'Weight'}}</span>
                          </div>
                        </div>
                        <div *ngIf="!(button.weights?.length > 0)" class="empty-state">
                          Nothing to show
                        </div>
                        <div class="card input-area" *ngFor="let weight of (button.weights || [])">
                          <div class="input-container" [ngClass]="{hidden: !hasMultipleGroups(selectedCompass)}" *ngVar="getGroupNames(selectedCompass, weight.groupGuids) as fieldValue" [title]="fieldValue">
                            <div class="label-line">
                              <span class="label">Score Groups</span>
                            </div>
                            <input type="text" class="input" [ngModel]="fieldValue" disabled />
                          </div>
                          <div class="input-container" *ngVar="weight.weight as fieldValue" [title]="fieldValue">
                            <div class="label-line">
                              <span class="label">Weight</span>
                            </div>
                            <input type="text" class="input" [ngModel]="fieldValue" disabled />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="getTab(selected.id) == 3" class="fields">
          <div class="input-area minimal">
            <div class="double">
              <div *ngIf="hasMultipleGroups(selectedCompass)" class="subheader-line">
                <div class="subheader-text">
                  <span class="subheader">Score Groups</span>
                </div>
              </div>
              <div *ngIf="!(selectedCompass.scoreSummaryGroups?.length > 0)" class="empty-state">
                Nothing to show
              </div>
              <div class="card input-area has-title no-overflow" [ngClass]="{'hidden-wrapper': !hasMultipleGroups(selectedCompass)}" *ngFor="let scoreGroup of (selectedCompass.scoreSummaryGroups || [])">
                <div *ngIf="hasMultipleGroups(selectedCompass)" class="double card-title">
                  <span class="title">{{(scoreGroup.name || '').trim() || 'Score Group'}}</span>
                </div>
                <div class="input-container double" *ngVar="(scoreGroup.name || 'Group') as fieldValue" [title]="fieldValue">
                  <div class="label-line">
                    <span class="label">Name</span>
                  </div>
                  <input type="text" class="input" [ngModel]="fieldValue" disabled />
                </div>
                <div class="double">
                  <div class="subheader-line">
                    <div class="subheader-text">
                      <span class="subheader">Scale Ranges</span>
                    </div>
                  </div>
                  <div *ngIf="!(scoreGroup.scaleRanges?.length > 0)" class="empty-state">
                    Nothing to show
                  </div>
                  <div class="card input-area" *ngFor="let range of (scoreGroup.scaleRanges || []); index as i">
                    <div class="input-container" *ngVar="(i + 1) as fieldValue" [title]="fieldValue">
                      <div class="label-line">
                        <span class="label">Range ID</span>
                      </div>
                      <input type="text" class="input" [ngModel]="fieldValue" disabled />
                    </div>
                    <div class="input-container" *ngVar="range.name as fieldValue" [title]="fieldValue">
                      <div class="label-line">
                        <span class="label">Text</span>
                      </div>
                      <input type="text" class="input" [ngModel]="fieldValue" disabled />
                    </div>
                    <div class="input-container" *ngVar="range.minimum as fieldValue" [title]="fieldValue">
                      <div class="label-line">
                        <span class="label">Minimum</span>
                      </div>
                      <input type="text" class="input" [ngModel]="fieldValue" disabled />
                    </div>
                    <div class="input-container" *ngVar="range.maximum as fieldValue" [title]="fieldValue">
                      <div class="label-line">
                        <span class="label">Maximim</span>
                      </div>
                      <input type="text" class="input" [ngModel]="fieldValue" disabled />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="selectedCompass.scoreSummaryGroups?.length > 1" class="double">
              <div class="subheader-line">
                <div class="subheader-text">
                  <span class="subheader">Summary Scale Ranges</span>
                </div>
              </div>
              <div *ngIf="!(selectedCompass.scoreSummaryRanges?.length > 0)" class="empty-state">
                Nothing to show
              </div>
              <div class="card input-area" *ngFor="let range of (selectedCompass.scoreSummaryRanges || []); index as i">
                <div class="input-container" *ngVar="(i + 1) as fieldValue" [title]="fieldValue">
                  <div class="label-line">
                    <span class="label">Range ID</span>
                  </div>
                  <input type="text" class="input" [ngModel]="fieldValue" disabled />
                </div>
                <div class="input-container" *ngVar="range.name as fieldValue" [title]="fieldValue">
                  <div class="label-line">
                    <span class="label">Text</span>
                  </div>
                  <input type="text" class="input" [ngModel]="fieldValue" disabled />
                </div>
                <div class="input-container" *ngVar="range.minimum as fieldValue" [title]="fieldValue">
                  <div class="label-line">
                    <span class="label">Minimum</span>
                  </div>
                  <input type="text" class="input" [ngModel]="fieldValue" disabled />
                </div>
                <div class="input-container" *ngVar="range.maximum as fieldValue" [title]="fieldValue">
                  <div class="label-line">
                    <span class="label">Maximim</span>
                  </div>
                  <input type="text" class="input" [ngModel]="fieldValue" disabled />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="sidebarTab == 'review'" class="buttons">
        <mat-progress-spinner *ngIf="false" class="spinner" color="primary" mode="indeterminate"
          diameter="21">
        </mat-progress-spinner>
        <button mat-button class="text-button secondary" [disabled]="submitting" (click)="submit(false)">Reject</button>
        <button mat-button class="text-button" [disabled]="submitting" (click)="submit(true)">Approve</button>
      </div>
      <div *ngIf="sidebarTab == 'modify'" class="buttons">
        <button mat-button class="text-button" [disabled]="submitting || !getSelectedCompass()" (click)="submit()">Modify</button>
      </div>
    </div>
  </div>
</div>
